import { request } from "../util";

export const createBlog = async () => {
   try {
      const res = await request.get("/blog/create");
      return res.data;
   } catch (error) {
      throw error;
   }
};

export const getBlogs = async () => {
   try {
      const res = await request.get("/blog");
      return res.data;
   } catch (error) {
      throw error;
   }
};

export const getPublishedBlog = async () => {
   try {
      const res = await request.get("/blogs");
      return res.data;
   } catch (error) {
      throw error;
   }
};

export const getUnpublishedBlog = async () => {
   try {
      const res = await request.get("/blog/unpublished");
      return res.data;
   } catch (error) {
      throw error;
   }
};

export const updateBlog = async () => {
   try {
      const res = await request.post("/blog/update");
      return res.data;
   } catch (error) {
      throw error;
   }
};

export const getBlogDetails = async (slug) => {
   try {
      const res = await request.get(`/blogs/${slug}`);
      return res.data;
   } catch (error) {
      throw error;
   }
};
